<template>
  <div class="tech-dropdown">
    <div class="tech-dropdown-toggle">
      <a href="javascript:void(0);" @click="ddToggle">
        <i class="material-icons-outlined align-middle">more_horiz</i>
      </a>
    </div>
    <div class="tech-dropdown-menu" v-show="params.data.ddOpen">
      <ul>
        <li>
          <a href="javascript:void(0);" @click="createInvoice">
            <i class="material-icons-outlined align-middle">credit_card</i>
            Create Invoice
          </a>
        </li>
        <li v-if="params.data.tech_stripe_id">
          <a href="javascript:void(0);" @click="toStripe"
            ><i class="material-icons-outlined align-middle">credit_card</i
            >Stripe</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { httpGet } from "@/http/http";

export default {
  computed: {
    isOpen() {
      return this.params.data.ddOpen;
    },
  },
  watch: {
    isOpen: function (val) {
      if (val) {
        let offset = this.$el.getBoundingClientRect();
        if (document.body.clientHeight - offset.top < 230) {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "auto";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "37px";
        } else {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "40px";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "auto";
        }
      }
    },
  },
  methods: {
    ddToggle: function () {
      this.params.data.ddOpen = !this.params.data.ddOpen;
      this.params.context.componentParent.openCurrentAgDropdown(
        this.params.data,
        this.$el
      );
    },
    createInvoice: function () {
      // console.log("createInvoice");
      // const startTime = moment()
      //   .subtract(1, "month")
      //   .startOf("month")
      //   .format("YYYY-MM-DD");
      // const endTime = moment()
      //   .subtract(1, "month")
      //   .endOf("month")
      //   .format("YYYY-MM-DD");
      // const data = {
      //   startTime,
      //   endTime,
      //   companyId: this.params.data.company_id,
      //   projectId: this.params.data.project_id,
      // };
      // httpGet("create_invoice", data)
      //   .then((response) => {
      //     if (response.ok) {
      //       this.$toasted.global.toast_success({
      //         message: "create success",
      //       });
      //       this.closeEditPannel();
      //     } else {
      //       this.$toasted.global.toast_error({
      //         message: response.message || "create error",
      //       });
      //     }
      //   })
      //   .finally(() => {
      //     this.companyInvoiceSubmitLoading = false;
      //   });
      this.params.context.componentParent.onCreateInvoice(
        this.params.data.company_id,
        this.params.data.project_id
      );
      this.ddToggle();
    },
    toStripe: function () {
      window.open(
        `https://dashboard.stripe.com/connect/accounts/${this.params.data.tech_stripe_id}/activity`,
        "_blank"
      );
      this.ddToggle();
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
</style>
